// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import Vue from "vue";
import VueRouter from "vue-router";

const TagScanned = () => import(/* webpackChunkName: "card-scan" */ '../views/TagScanned');

const ResetPasswordRequest = () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPasswordRequest');
const ResetPassword = () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPassword');

const Login = () => import(/* webpackChunkName: "pharma-app" */ '../views/Login');
const TopPage = () => import(/* webpackChunkName: "pharma-app" */ '../views/TopPage');
const PatientList = () => import(/* webpackChunkName: "pharma-app" */ '../views/PatientList');
const Patient = () => import(/* webpackChunkName: "pharma-app" */ '../views/Patient');

import dataStore from '../store'

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    { path: "/tag",
      component: TagScanned,
      props: (route) => ({ tagId: route.query.tagId, tagid: route.query.tagid })
    },
    { path: "/login",
      name: "login",
      component: Login },
    { path: "/reset-password/request",
      name: "passwordResetRequest",
      component: ResetPasswordRequest,
    },
    { path: "/reset-password/:rid",
      name: "changePassword",
      component: ResetPassword,
      props: true,
    },
    { path: "/patients", component: TopPage,
      beforeEnter(to, from, next) {
        if (dataStore.getters.isAuthenticated) {
          next();
        } else {
          next("/login");
        }
      },
      children: [
        { path: "list",
          name: "patientList",
          component: PatientList,
          meta: {title: "Patient List"}
        },
        { path: ":pid",
          name: "patient",
          component: Patient,
          meta: {title: "Patient"},
          props: true,
        },
      ]
    },
    { path: "*", redirect: "/login" }
  ]
});
